export class BlockKeywordCommand {
    constructor(
        public value: string,
        public type: string) {
    }
}

export class RevertCommand {
    constructor(
        public id: string) {
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/accounts/block.keyword.command.ts